import { render, staticRenderFns } from "./wuju-topic-list.vue?vue&type=template&id=1d898948&scoped=true&"
import script from "./wuju-topic-list.vue?vue&type=script&lang=js&"
export * from "./wuju-topic-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d898948",
  null
  
)

export default component.exports